import { createFileRoute } from '@tanstack/react-router'
import { AutomationDetailPage } from '@/pages/automations/automation-detail/automation-detail-page'
import { WorkspaceEntitlementGate } from '@/features/workspace-entitlements/ui/workspace-entitlement-gate'
import { WorkspaceEntitlementKey } from '@/graphql/schema'

export const Route = createFileRoute('/automations/$id/')({
  component: () => (
    <WorkspaceEntitlementGate feature={WorkspaceEntitlementKey.Automations}>
      <AutomationDetailPage />
    </WorkspaceEntitlementGate>
  ),
})
